import session from '@/shared/session'

const initialState = () => ({
	patient: {
		procedures: [],
	},
	decursus: {
		procedures: [],
	}
})

const state = initialState()

// getters
const getters = {
	getPatientProcedures: (state) => () => {
		return state.patient.procedures
	},
	getDecursusProcedures: (state) => () => {
		return state.decursus.procedures
	}
}

// actions
const actions = {
	resetState ({ commit }) {
		commit('reset_state')
	},

	async filterProcedures({ commit, state }, params) {
		const items = await session
			.get('/api/procedures/types/', {
					params: params
			})

		return items.data
	},

	async filterPatientProcedures({ state, commit }, data) {
		const procedures = await session
			.get("/api/procedures/", {
				params: data,
			})
		return procedures.data
	},

	async exportBatch({ commit }, data) {
		const batch = await session
			.post(`/api/procedures/export_batch/`, data)

		return batch.data
	},

	async getCurrentExports({ commit }, data) {
		const batch = await session
			.get(`/api/procedures/exports_batch/`, {
				params: data
			})

		return batch.data
	},

	async getRunningExports({ commit }, data) {
		const batch = await session
			.get(`/api/procedures/running_exports_batch/`, {
				params: data
			})

		return batch.data ? batch.data.running : false
	},

	async getCurrentExport({ commit }, data) {
		const batch = await session
			.get(`/api/procedures/current_export_batch/`, {
				params: data
			})

		return batch.data
	},

	async getProceduresForCurrentDecursus({ commit, state, rootState }) {
		if (!rootState.decursus.current) {
			return
		}
		const procedures  = await session
			.get(`/api/decursus/${rootState.decursus.current?.id}/procedures/`)

		commit("set_decursus_procedures", procedures.data)

		return state.decursus.procedures
	},

	async getProceduresByDecursusId({ commit, state }, id) {
		const procedures  = await session
			.get(`/api/decursus/${id}/procedures/`)

		return procedures.data
	},

	async getProceduresForCurrentPatient({ commit, state, rootState }) {
		if (!rootState.patients.current) {
			return
		}
		
		const procedures  = await session
			.get(`/api/patients/${rootState.patients.current?.id}/procedures/`)

		commit("set_patient_procedures", procedures.data)

		return state.patient.procedures
	},

	createProcedureForCurrentPatient({ commit, rootState, dispatch }, data) {
		dispatch("loading/load", "procedures", { root: true })
		return session
				.post(`/api/procedures/`, {...data,  decursus: rootState.patients.current?.current_consult?.decursus_id})
				.then(() => {
					return dispatch("getProceduresForCurrentPatient")
				})
				.then(() => {
					return dispatch("getProcedureByCurrentDecursus")
				})
	      .finally(() => {
	        dispatch("loading/end", "procedures", { root: true })
	      })
	},

	// createPatientProcedure({ commit, rootState, dispatch }, data) {
	// 	dispatch("loading/load", "procedures", { root: true })
	// 	return session
	// 			.post(`/api/procedures/`, {...data,  decursus: rootState.decursus.current?.id})
	// 			.then(() => {
	// 				return dispatch("getProceduresForCurrentPatient")
	// 			})
	//       .finally(() => {
	//         dispatch("loading/end", "procedures", { root: true })
	//       })
	// },
	// updatePatientProcedure({ commit, rootState, dispatch }, { id, data }) {
	// 	dispatch("loading/load", "procedures", { root: true })
	// 	return session
	// 			.patch(`/api/procedures/${id}/`, data)
	// 			.then(() => {
	// 				return dispatch("getProceduresForCurrentPatient")
	// 			})
	//       .finally(() => {
	//         dispatch("loading/end", "procedures", { root: true })
	//       })
	// },

	// deletePatientProcedure({ commit, dispatch }, id) {
	// 	dispatch("loading/load", "procedures", { root: true })
	// 	return session
	// 			.delete(`/api/procedures/${id}/`)
	// 			.then(() => {
	// 				return dispatch("getProceduresForCurrentPatient")
	// 			})
  //     .finally(() => {
  //       dispatch("loading/end", "procedures", { root: true })
  //     })
	// },

	createProcedure({ commit, rootState, dispatch }, data) {
		dispatch("loading/load", "procedures", { root: true })
		return session
				.post(`/api/procedures/`, data)
				.then(() => {
					return dispatch("getProceduresForCurrentPatient")
				})
	      .finally(() => {
	        dispatch("loading/end", "procedures", { root: true })
	      })
	},

	createDecursusProcedure({ commit, rootState, dispatch }, data) {
		dispatch("loading/load", "procedures", { root: true })
		return session
				.post(`/api/procedures/`, {...data,  decursus: rootState.decursus.current?.id})
				.then(() => {
					dispatch("getProceduresForCurrentPatient")
					return dispatch("getProceduresForCurrentDecursus")
				})
	      .finally(() => {
	        dispatch("loading/end", "procedures", { root: true })
	      })
	},
	updateDecursusProcedure({ commit, rootState, dispatch }, { id, data }) {
		dispatch("loading/load", "procedures", { root: true })
		return session
				.patch(`/api/procedures/${id}/`, data)
				.then((updated) => {
					dispatch("getProceduresForCurrentPatient")
					dispatch("getProceduresForCurrentDecursus")
					return updated.data
				})
	      .finally(() => {
	        dispatch("loading/end", "procedures", { root: true })
	      })
	},

	deleteDecursusProcedure({ commit, dispatch }, id) {
		dispatch("loading/load", "procedures", { root: true })
		return session
				.delete(`/api/procedures/${id}/`)
				.then(() => {
					dispatch("getProceduresForCurrentPatient")
					return dispatch("getProceduresForCurrentDecursus")
				})
      .finally(() => {
        dispatch("loading/end", "procedures", { root: true })
      })
	},
}

// mutations
const mutations = {
  reset_state(state) {
		Object.assign(state, initialState())
  },

	set_patient_procedures(state, procedures) {
		state.patient.procedures = procedures
	},
	set_decursus_procedures(state, procedures) {
		state.decursus.procedures = procedures
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}